import packageJson from '../../package.json';

export const environment = {
  production: false,
  apiBaseUrl: 'https://api.doktar.cc',
  appId: '895BAB77-F072-4069-B2BC-20872CF94DEA', // Fieldwork App ID
  enableServiceWorker: true,
  maxDistanceForEntry: 1000, // 1km proximity rule in meters
  appVersion: packageJson.version,
  locationPermissionHelpUrl: 'https://doktar.getoutline.com/s/1828d14c-0ad4-479d-a674-659342db8a4b',
};

